<template>
  <div
    :class="['record_item ', {'is-active': isActive}]"
    @click="$emit('click')"
    v-observe-visibility="{
      callback: isVisible,
      once: true,
    }"
  >
    <div class="flex flex-between">
      <div>
        <p class="record_item--status">Status: {{ status.label }}</p>
        <sensitive-data-wrapper>
          <h3 class="record_item--heading">{{ propertyAddress.line1 }}</h3>
          <p v-if="propertyAddress.line2" class="record_item--city">{{ propertyAddress.line2 }}</p>
        </sensitive-data-wrapper>
      </div>

      <record-icons :record="record" include-temp tooltip-position="is-left"></record-icons>
    </div>

    <p :class="['record_item--follow_up', {'paused': isFollowUpPaused}]">
      <template v-if="isAutomated">
        <span>{{ isFollowUpPaused ? "Paused" : 'Sequence' }}</span>: <strong>{{ followUpLabel }}</strong>
      </template>
    </p>

    <p class="record_item--info">Last Contacted: {{ lastContactedAt ? lastContactedAt : "Not Contacted" }}</p>
    <p
      v-if="isManual"
      :class="['record_item--info', {'is_past_next_contact': isPastNextContact}]"
    >Next Contact At: {{ nextContactAt ? nextContactAt : "None Set" }}</p>
  </div>
</template>

<script>
import {ENUMS} from "../../../../../services/enums";
import dates from "../../../../../services/dates";
import SensitiveDataWrapper from "../../../../../components/SensitiveDataWrapper.vue";
import AppDebugging from "../../../../../components/app/AppDebugging.vue";

export default {
  name: "FollowUpItem",
  components: {AppDebugging, SensitiveDataWrapper},
  props: {
    record: {},
    isActive: {
      type: Boolean,
      default: false
    },
    isManual: {
      type: Boolean,
      default: false
    },
    isAutomated: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      nowDate: dates.getNowISO()
    }
  },
  computed: {
    // nextTask() {
    //   if (this.record.nextTask) {
    //     return dates.getISO(this.record.nextTask.due_at);
    //   }
    //
    //   return null;
    // },
    // recordIndicator() {
    //   if(dates.isBefore(this.nextTask, this.nowDate)) {
    //     return 'is-danger';
    //   } else if (dates.isBefore(this.nextTask, dates.addDay(this.nowDate))) {
    //     return 'is-warning';
    //   }
    //
    //   return '';
    // },
    followUpSequence() {
      return this.$store.getters['followUpState/lazyLoadedFollowUpSequenceData'](this.record.active_sequence_id);
    },

    followUpLabel() {
      if (this.record.active_sequence_template_id) {
        const template = this.$store.getters.fusTemplates.find(template => template.id === this.record.active_sequence_template_id);
        return template.label;
      }

      if (this.record.contact && this.record.contact.active_sequence_template_id) {
        const template = this.$store.getters.fusTemplates.find(template => template.id === this.record.contact.active_sequence_template_id);
        return template.label;
      }

      return null;
    },

    isFollowUpPaused() {
      if(this.record.active_sequence_status) {
        return this.record.active_sequence_status === ENUMS.FollowUpSequenceStatusEnum.Paused.value;
      }

      if (this.record.contact && this.record.contact.active_sequence_status) {
        return this.record.contact.active_sequence_status === ENUMS.FollowUpSequenceStatusEnum.Paused.value;
      }

      return false;
    },

    isPastNextContact() {
      const now = new Date();
      const nextContactAt = new Date(this.record.next_contact_at);

      return nextContactAt.getTime() <= now.getTime();
    },

    lastContactedAt() {
      const lastContactedAt = this.record.last_contacted_at;

      if (lastContactedAt) {
        return dates.formatAsDateTime(lastContactedAt);
      }

      return null;
    },

    nextContactAt() {
      const nextContactAt = this.record.next_contact_at;

      if (nextContactAt) {
        return dates.formatAsDateTime(nextContactAt);
      }

      return null;
    },

    propertyAddress() {
      const property = this.record.property;

      return {
        line1: property.line_1 ? property.line_1 : "Unknown Address",
        line2: property.city ? [
          property.city,
          property.state
        ].join(", ") : null,
      };
    },

    status() {
      return this.$store.getters['pipeline/statuses'].find(status => status.id === this.record.current_status_id);
    }
  },
  methods: {
    isVisible(isVisible) {
      if (isVisible && !this.followUpSequence) {
        this.$store.commit('followUpState/addFollowUpSequenceToPendingLazyLoadedFollowUpSequences', this.record.active_sequence_id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.record_item {
  padding: 8px;
  border-left: 4px solid transparent;
  border-bottom: 1px solid $border;
  cursor: pointer;

  //&.is-warning {
  //  border-left-color: $yellow;
  //}
  //&.is-danger {
  //  border-left-color: $red;
  //}

  &:hover {
    background-color: $white;
    border-left-color: $grey-100;
  }

  &.is-active {
    border-left-color: $primary;
    background-color: $white;
  }

  &--status {
    margin-bottom: 6px;
    font-size: 0.75rem;
    color: $text-light;
  }

  &--heading {
    margin-bottom: 10px;
    font-weight: 600;
  }

  &--city {
    margin-top: -8px;
    margin-bottom: 10px;
    font-size: 0.75rem;
  }

  &--follow_up {
    margin: 6px 0 12px;
    font-size: 0.875rem;
    color: $text-muted;
    line-height: 1.3;

    &.paused {

      span {
        color: $primary;
      }
    }
  }

  &--info {
    margin-top: 6px;
    font-size: 0.875rem;
    color: $text-muted;

    &.is_past_next_contact {
      color: $danger;
    }
  }
}
</style>
